export default "__VITE_ASSET__Dar40pgA__"